/* eslint-disable array-callback-return, eqeqeq, no-loop-func */

import React, { useState, useEffect, forwardRef } from "react";
import { connect } from "react-redux";
import {
  Select as MSelect,
  Input,
  ListItemText,
  IconButton,
  Chip,
  TextField,
  RadioGroup,
  Radio,
  FormControlLabel,
  Button,
  Checkbox,
  MenuItem,
  InputAdornment,
} from "@material-ui/core/";
import Close from "@material-ui/icons/Close";
import icon_checkbox_checked_round from "assets/images/icon-checkbox-checked-round.png";
import icon_checkbox_round from "assets/images/icon-checkbox-round.png";
import icon_checkbox_grey_outline from "assets/images/icon-checkbox-grey-outline.svg";
import icon_checkbox_grey from "assets/images/icon-checkbox-grey.svg";
import icon_radio_outline from "assets/images/icon-radio-outline.svg";
import icon_radio from "assets/images/icon-radio.svg";
import { Link, Prompt } from "react-router-dom";
import device_information from "assets/images/device-information.svg";
import icon_radio_grey_outline from "assets/images/icon-radio-grey-outline.svg";
import icon_radio_grey from "assets/images/icon-radio-grey.svg";
import consent_Form_pdf from "assets/images/pdf/Consent_Form.pdf";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import PastDateAllocationDevice from "components/CustomDialogs/DeviceOperations/pastDateAllocationDevice-dialog";
import PastDateDeliverySuccess from "components/CustomDialogs/DeviceOperations/PastDateDeliverySuccess-dialog";
import { validateSearchText } from "common/index";
import 'antd/dist/antd.css';

import {
  fetch_disease_list as fetch_disease_list_action,
  generate_patient_id as generate_patient_id_action,
  add_new_patient as add_new_patient_action,
  reset_new_patient_validation as reset_new_patient_validation_action,
  reset_new_patient_response as reset_new_patient_response__action,
} from "actions/patients";
import {
  fetch_available_devices as fetch_available_devices_action,
  device_operation,
  fetch_available_devices_dates as fetch_available_devices_dates_action,
} from "actions/user";
import ConfirmDialog from "components/CustomDialogs/Common/confirm-dialog";
import { getLocalMoment } from "util/timeZoneDate";
import IntlMessages from "util/IntlMessages";
import { TimezoneSelect, allTimezones } from "timezone-select-js";
import { defaultWindowEndTime, defaultWindowStartTime } from "util/helpers";

dayjs.extend(utc);

const currentYear = dayjs()
  .subtract(18, "years")
  .utc()
  .toDate()
  .getFullYear();
const range = (start, stop, step) =>
  Array.from({ length: (stop - start) / step + 1 }, (_, i) => ({
    value: start + i * step,
    label: start + i * step,
  }));
const yearOptions = range(currentYear, currentYear - 100, -1);

const initialForm = {
  addPatientPageNo: 1,
  first_name: "",
  last_name: "",
  email_id: "",
  patientId: "",
  yearOfBirth: "",
  gender: "",
  selectedDiseases: [],
  selectedDiseaseIds: [],
  weight: "",
  height: "",
  bmi: 0,
  bmiState: "",
  atRisk: null,
  window_start_time: dayjs().format('HH:mm:ss'),
  window_end_time: dayjs().format('HH:mm:ss'),
  comments: "",
  nightsBetween: "1",
  deviceSelected: "",
  deviceMasterID: "",
  diseaseMenuOpenFlag: false,
  country: "",
};

const errors = {
  patientIDError: "",
  yearOfBirthError: "",
  genderError: "",
  diseaseError: "",
  weightError: "",
  heightError: "",
};

const initialQuestionnaire = {
  first: null,
  second: null,
  third: null,
  forth: null,
};

const AddPatient = (props) => {
  const { patients, fetch_disease_list, user } = props;
//   const [openStartWindow, setOpenStartWindow] = useState(false);
//   const [openStopWindow, setOpenStopWindow] = useState(false);
  const [addPatientForm, setAddPatientForm] = useState(initialForm);
  const [formErrors, setFormErrors] = useState(errors);
  const [diseaseList, setDiseaseList] = useState([]);
  const [deviceData, setdeviceData] = useState([]);
  const [deployError, setDeployError] = useState(false);
  const [questionnaire, setQuestionnaire] = useState({
    ...initialQuestionnaire,
  });
  const [disableAddPatient, setDisableAddPatient] = useState(false);
  const [searchDeviceId, setSearchDeviceId] = useState("");
  const [greenDotDates, setGreenDotDates] = useState([]);

  const [pastDateAllocation, setPastDateAllocation] = useState(false);
  const [pastDateSuccess, setPastDateSuccess] = useState(false);
  const [pastDate, setPastDate] = useState(null);
  const [reqestPastDateDeployDevice, setReqestPastDateDeployDevice] = useState(
    ""
  );
  const [showPrompt, setShowPrompt] = useState(false);
  const [newLocation, setNewLocation] = useState("");
  const [preventRedirect, setPreventRedirect] = useState(true);
  const [country, setCountry] = useState({ value: "", errors: {} });
  const customTimezones = [
    { label: "Switzerland", value: "Europe/Zurich" },
    { label: "Asia/Calcutta", value: "Asia/Kolkata" },
  ];

  useEffect(
    () => {
      if (preventRedirect === false) {
        props.history.push(newLocation === "" ? "/app/patients" : newLocation);
      }
    },
    [preventRedirect]
  );

  useEffect(
    () => {
      if (patients.is_patient_added && !pastDate) {
        props.reset_new_patient_response();
        setPreventRedirect(false);
      }
    },
    [patients.is_patient_added]
  );

  useEffect(() => {
    props.reset_new_patient_validation();
    fetch_disease_list({});
    user.device_operation_success_response = null;

    if (
      user &&
      (!user.available_devices_dates ||
        user.available_devices_dates.length === 0)
    ) {
      props.fetch_available_devices_dates();
    }
  }, []);

  useEffect(
    () => {
      if (deviceData.length === 1) {
        selectAvailableDevice(null, deviceData[0].device_id);
      }
    },
    [deviceData]
  );

  useEffect(
    () => {
      if (
        user &&
        user.available_devices_dates &&
        user.available_devices_dates.length > 0
      ) {
        const dates = [];
        user.available_devices_dates.forEach((d) => {
          dates.push(new Date(d));
        });

        setGreenDotDates([...dates]);
      }
    },
    [user.available_devices_dates]
  );

  useEffect(
    () => {
      if (
        addPatientForm.deviceAllocationDate &&
        addPatientForm.deviceDeallocationDate &&
        !pastDate
      ) {
        let diff =
          (addPatientForm.deviceDeallocationDate.getTime() -
            addPatientForm.deviceAllocationDate.getTime()) /
          86400000;

        setAddPatientForm({
          ...addPatientForm,
          nightsBetween: Math.round(diff),
          deviceSelected: null,
        });
        props.fetch_available_devices({
          allocation_time: new Date(
            addPatientForm.deviceAllocationDate
          ).getTime(),
          deallocation_time: new Date(
            addPatientForm.deviceDeallocationDate
          ).getTime(),
        });
        // setQuestionnaire({ ...initialQuestionnaire });
        setDisableAddPatient(false);
      }
      if (pastDate) {
        let diff =
          (addPatientForm.deviceDeallocationDate.getTime() -
            addPatientForm.deviceAllocationDate.getTime()) /
          86400000;
        setAddPatientForm({
          ...addPatientForm,
          nightsBetween: Math.round(diff),
        });
        setDisableAddPatient(false);
      }
    },
    [addPatientForm.deviceAllocationDate, addPatientForm.deviceDeallocationDate]
  );

  useEffect(
    () => {
      if (
        addPatientForm.deviceSelected &&
        addPatientForm.deviceSelected !== "" &&
        questionnaire.first !== "no" &&
        questionnaire.second !== "no" &&
        questionnaire.third !== "no" &&
        questionnaire.forth !== "yes"
      ) {
        setDisableAddPatient(true);
      }
    },
    [addPatientForm.deviceSelected]
  );

  useEffect(
    () => {
      const {
        available_devices,
        deployed_device_in_past_date,
        device_operation_success_response,
        device_operation_error_response,
      } = user;

      if (available_devices && available_devices.length > 0) {
        setdeviceData(available_devices);
      } else {
        setdeviceData([]);
      }

      let msg = "";
      if (device_operation_success_response) {
        const { message, details } = device_operation_success_response;
        if (message && details) {
          if (message.indexOf("mapped") > 0) {
            msg =
              "The device is not allocated for the physician for the specified range.";
          } else if (
            message.indexOf("occupied") > 0 &&
            details[0].device_id === addPatientForm.deviceSelected
          ) {
            let patient = details[0].patient_code;
            let fromDate = dayjs
              .utc(details[0].device_allocation_date)
              .format("DD MMM YYYY");
            let returnDate = dayjs
              .utc(details[0].device_deallocation_date)
              .format("DD MMM YYYY");
            if (pastDate) {
              msg = `This device is already reserved for patient ${patient} from ${fromDate} to ${returnDate}.`;
            } else {
              msg = `This device is already reserved for patient ${patient} from ${fromDate} to ${returnDate}. To cancel the booking of patient ${patient} and deploy the device for ${
                addPatientForm.patientId
              } click on deploy below.`;
            }
          } else if (
            message ===
            `This patient is already assigned to other device during these dates.`
          ) {
            // msg = message;
            let fromDate = dayjs
              .utc(details[0].device_allocation_date)
              .format("DD MMM YYYY");
            let returnDate = dayjs
              .utc(details[0].device_deallocation_date)
              .format("DD MMM YYYY");
            msg = `This patient is already assigned ${
              details[0].device_id
            } device for future dates start from ${fromDate} to ${returnDate}.`;
            // document.getElementsByClassName("popup-content")[0].scrollTo(0, 0);
          }
          setDeployError(msg);
          setPastDateAllocation(true);
        } else {
          // NOTE: Deploy only if device-operation was a success
          setPastDateAllocation(false);
          setNewLocation("/app/patients");
          setPreventRedirect(false);
        }
      }

      if (device_operation_error_response) {
        // NOTE: checkout deployment message
        setDeployError(
          "Deployment for the specified date failed. However you can request admin below"
        );
      }

      let deployed_device_in_past_date_msg = "";
      if (
        deployed_device_in_past_date &&
        deployed_device_in_past_date.message &&
        deployed_device_in_past_date.message !== ""
      ) {
        deployed_device_in_past_date_msg = deployed_device_in_past_date.message;
        const device_information_block = document.getElementById(
          "add_patient_device_information"
        );
        if (device_information_block) {
          device_information_block.scrollIntoView();
        }
      }
      setReqestPastDateDeployDevice(deployed_device_in_past_date_msg);
    },
    [user]
  );

  useEffect(
    () => {
      const { generated_id } = patients;
      if (generated_id) {
        setAddPatientForm({ ...addPatientForm, patientId: generated_id });
        setFormErrors({ ...formErrors, patientIDError: "" });
      }
    },
    [patients.generated_id]
  );

  useEffect(
    () => {
      setDiseaseList(patients.fetch_disease_list_data);
      setAddPatientForm({
        ...initialForm,
        country: addPatientForm.country,
        window_start_time: user.user_details.window_start_time,
        window_end_time: user.user_details.window_end_time,
      });
    },
    [patients.fetch_disease_list_data]
  );

  useEffect(
    () => {
      if (
        formErrors.patientIDError === null &&
        formErrors.yearOfBirthError === null &&
        formErrors.genderError === null &&
        formErrors.diseaseError === null &&
        formErrors.weightError === null &&
        formErrors.heightError === null
      ) {
        setAddPatientForm({
          ...addPatientForm,
          addPatientPageNo: 2,
          deviceAllocationDate: dayjs.utc().toDate(),
          deviceDeallocationDate: dayjs
            .utc()
            .add(1, "days")
            .toDate(),
        });
      }
    },
    [formErrors]
  );

  useEffect(
    () => {
      var { is_patient_added, is_adding_patient } = patients;
      if (is_adding_patient !== undefined) {
        let error =
          !is_adding_patient &&
          !is_patient_added &&
          patients.error === "patient_id_exists"
            ? "Patient ID already exist"
            : null;
        if (error !== null) {
          setAddPatientForm({ ...addPatientForm, addPatientPageNo: 1 });
          setFormErrors({ ...formErrors, patientIDError: error });
        }
        if (
          addPatientForm.addPatientPageNo === 2 &&
          is_adding_patient === false &&
          is_patient_added === true
        ) {
          setShowPrompt(false);
          // setNewLocation('/app/patients');
          // setPreventRedirect(false);
        }
      }
    },
    [patients.is_adding_patient]
  );

  const handleInputChange = (e, v) => {
    if (v) {
      setCountry({
        value: v,
      });

      setAddPatientForm((prev) => ({
        ...prev,
        country: country.value,
      }));
    }
    // setCountry({ errors: {} });
  };

  const fixTimezone = (givenZone) => {
    customTimezones.map((val) => {
      if (val.label === givenZone) {
        setCountry({
          value: val.value,
        });
        setAddPatientForm((prev) => ({
          ...prev,
          country: val.value,
        }));
      }
    });
    if (country.value === null || country.value === "") {
      setCountry({
        value: givenZone,
      });
      setAddPatientForm((prev) => ({
        ...prev,
        country: givenZone,
      }));
    }
  };

  useEffect(
    () => {
      if (user.user_details.country) {
        fixTimezone(user.user_details.country);
      } else {
        let currentTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        fixTimezone(currentTimezone);
        if (country.value === null) {
          setCountry({
            value: currentTimezone,
          });
          setAddPatientForm((prev) => ({
            ...prev,
            country: currentTimezone,
          }));
        }
      }
    },
    [user]
  );

  useEffect(
    () => {
      setAddPatientForm((prev) => ({
        ...prev,
        country: country.value,
      }));
    },
    [country,addPatientForm.country]
  );

  useEffect(() => {
    let winStart=null, winStop=null;
    deviceData && deviceData.forEach((e)=>{
        if(Number(addPatientForm.deviceSelected) === Number(e.device_id)) {
            console.log('Starting : ',e)
            winStart=e.window_start_time;
            winStop=e.window_end_time;
        }
    })
    if (!winStart && !winStop && addPatientForm.deviceSelected) {
        setAddPatientForm(prev => ({
          ...prev,
          window_start_time: defaultWindowStartTime,
          window_end_time: defaultWindowEndTime,
        }));
      } else {
        setAddPatientForm(prev => ({
          ...prev,
          window_start_time: winStart,
          window_end_time: winStop,
        }));
      }
  }, [deviceData,addPatientForm.deviceSelected]);

  const diseaseMenuToggle = () => {
    setAddPatientForm({
      ...addPatientForm,
      diseaseMenuOpenFlag: !addPatientForm.diseaseMenuOpenFlag,
    });
    if (!addPatientForm.diseaseMenuOpenFlag) {
      setDiseaseList(patients.fetch_disease_list_data);
    }
  };

  const onSelectDisease = (event) => {
    if (patients.fetch_disease_list_data) {
      var disease = patients.fetch_disease_list_data.find(
        (d) => d.disease_description === event.currentTarget.dataset.value
      );
      let remove_none = false,
        remove_all_but_none = false;

      if (disease) {
        if (addPatientForm.selectedDiseases.includes("None")) {
          // NOTE: if event has none and another value selected remove none and select other values
          if (
            event.target.value.includes !== "None" &&
            event.target.value.filter((v) => v !== "None").length
          ) {
            remove_none = true;
            event.target.value = event.target.value.filter((v) => v !== "None");
          }
        } else {
          // NOTE: if incoming values have none and other values, toggle to none;
          if (event.target.value.includes("None")) {
            remove_all_but_none = true;
            event.target.value = ["None"];
          }
        }

        if (
          JSON.stringify(event.target.value) !==
          JSON.stringify(addPatientForm.selectedDiseases)
        ) {
          let selectedDiseaseIds = [
            ...addPatientForm.selectedDiseaseIds,
            disease.disease_id,
          ];
          if (remove_none)
            selectedDiseaseIds = selectedDiseaseIds.filter((v) => v !== 1);
          if (remove_all_but_none) selectedDiseaseIds = [1];

          setAddPatientForm({
            ...addPatientForm,
            selectedDiseases: event.target.value,
            selectedDiseaseIds,
          });
          setFormErrors({ ...formErrors, diseaseError: "" });
        } else {
          setAddPatientForm({
            ...addPatientForm,
            selectedDiseases: event.target.value,
            selectedDiseaseIds: addPatientForm.selectedDiseaseIds.filter(
              (id) => id !== disease.disease_id
            ),
          });
        }
      }
    }
  };

  const cancelAddPatient = () => {
    setAddPatientForm(initialForm);
    setShowPrompt(false);
    props.history.goBack();
    setPreventRedirect(false);
    props.reset_new_patient_validation();
  };

  const onDeleteDisease = (chip) => {
    const chipsData = [...addPatientForm.selectedDiseases];
    const chipToDelete = chipsData.indexOf(chip);
    chipsData.splice(chipToDelete, 1);
    if (patients.fetch_disease_list_data) {
      var disease = patients.fetch_disease_list_data.find(
        (d) => d.disease_description === chip
      );
      setAddPatientForm({
        ...addPatientForm,
        selectedDiseases: chipsData,
        selectedDiseaseIds: addPatientForm.selectedDiseaseIds.filter(
          (id) => id !== disease.disease_id
        ),
      });
    }
  };

  const calculate_bmi = () => {
    const { weight, bmi, height } = addPatientForm;
    var finalBmi = bmi;

    if (weight > 0 && height > 0) {
      finalBmi = weight / (((height / 100) * height) / 100);
      finalBmi = finalBmi.toFixed(2);
    } else {
      finalBmi = 0;
    }

    let bmiState = "";
    if (finalBmi > 0 && finalBmi < 18.5) {
      bmiState = "Underweight";
    } else if (finalBmi >= 18.5 && finalBmi < 25) {
      bmiState = "Normal";
    } else if (finalBmi >= 25 && finalBmi < 30) {
      bmiState = "Pre-obesity";
    } else if (finalBmi >= 30 && finalBmi < 35) {
      bmiState = "Obesity class I";
    } else if (finalBmi >= 35 && finalBmi < 40) {
      bmiState = "Obesity class II";
    } else if (finalBmi > 40) {
      bmiState = "Obesity class III";
    }

    setAddPatientForm({ ...addPatientForm, bmi: finalBmi, bmiState: bmiState });
  };

  const validateForm = (e) => {
    e.preventDefault();
    if (addPatientForm.addPatientPageNo === 1) {
      let weightErrorText = null;
      if (addPatientForm.weight === "") {
        weightErrorText = "Please enter weight.";
      } else if (addPatientForm.weight == 0) {
        weightErrorText = "Please enter valid weight.";
      }

      let heightErrorText = null;
      if (addPatientForm.height === "") {
        heightErrorText = "Please enter height.";
      } else if (addPatientForm.height == 0) {
        heightErrorText = "Please enter valid height.";
      }

      setFormErrors({
        patientIDError: formErrors.patientIDError
          ? formErrors.patientIDError
          : addPatientForm.patientId
            ? null
            : "Please enter Patient ID.",
        yearOfBirthError: !addPatientForm.yearOfBirth
          ? "Please select year of birth."
          : null,
        genderError: !addPatientForm.gender ? "Please select gender." : null,
        diseaseError:
          addPatientForm.selectedDiseases.length === 0
            ? "Please select condition."
            : null,
        // weightError: addPatientForm.weight ? null : "Please enter weight.",
        // heightError: addPatientForm.height ? null : "Please enter height.",
        weightError: weightErrorText,
        heightError: heightErrorText,
      });
    }
  };

  const addNewPatient = async () => {
    // Using timezone as the property name for add-patient payload
    // country is for timezone in the context of state changes
    const payload = {
      patient_code: addPatientForm.patientId,
      first_name: "",
      last_name: "",
      email_id: "",
      gender: addPatientForm.gender,
      date_of_birth: dayjs(
        new Date().setYear(addPatientForm.yearOfBirth)
      ).format("YYYY-MM-DD"),
      at_risk: addPatientForm.atRisk,
      diseaseIds: addPatientForm.selectedDiseaseIds.toString(),
      height:
        addPatientForm.height[addPatientForm.height.length - 1] === "."
          ? parseInt(addPatientForm.height)
          : addPatientForm.height,
      weight:
        addPatientForm.weight[addPatientForm.weight.length - 1] === "."
          ? parseInt(addPatientForm.weight)
          : addPatientForm.weight,
      bmi: addPatientForm.bmi,
      vital_parameters: JSON.stringify({
        spo2: { modFrom: "90", modTo: "93", sevFrom: "40", sevTo: "89" },
        pr: {
          modFromF: "100",
          modToF: "120",
          modFromS: "60",
          modToS: "60",
          sevFromF: "0",
          sevToF: "55",
          sevFromS: "120",
          sevToS: "160",
        },
        br: {
          modFromF: "12",
          modToF: "12",
          modFromS: "24",
          modToS: "30",
          sevFromF: "0",
          sevToF: "10",
          sevFromS: "30",
          sevToS: "50",
        },
      }),
      comment: addPatientForm.comments,
      diseases: addPatientForm.selectedDiseases.toString(),
      country: addPatientForm.country,
      address: null,
      tags: null,
      device_allocation_date: addPatientForm.deviceSelected
        ? addPatientForm.deviceAllocationDate
        : null,
      device_deallocation_date: addPatientForm.deviceSelected
        ? addPatientForm.deviceDeallocationDate
        : null,
      device_master_id: addPatientForm.deviceSelected
        ? addPatientForm.deviceMasterID
        : null,
      device_id: addPatientForm.deviceSelected,
      docter_id: props.doctor_id,
      window_start_time: addPatientForm.window_start_time || defaultWindowStartTime,
      window_end_time: addPatientForm.window_end_time || defaultWindowEndTime,
    };

    if (!addPatientForm.deviceSelected) {
      const message = window.confirm(
        "You are adding a patient without deploying the device. Please click OK if you want to continue."
      );
      if (message == true) {
        setShowPrompt(false);
        setNewLocation("/app/patients");
        setPreventRedirect(true);
      } else {
        return false;
      }
    }
    await props.add_new_patient(payload);
  };

  const CustomDateInput = forwardRef(({ onClick, value }, ref) => (
    <button className="custom-date-input" onClick={onClick} ref={ref}>
      {value}
    </button>
  ));

  const toggleQuestionHandle = (order, value) => {
    let qData = { ...questionnaire };
    qData[order] = value;

    if (order === "first") {
      qData["second"] = null;
      qData["third"] = null;
      qData["forth"] = null;
    }

    if (order === "second") {
      qData["third"] = null;
      qData["forth"] = null;
    }

    if (order === "third") {
      qData["forth"] = null;
    }

    setQuestionnaire(qData);

    if (
      qData.first === "no" &&
      qData.second === "no" &&
      qData.third === "no" &&
      qData.forth === "yes"
    ) {
      setDisableAddPatient(false);
    } else {
      setDisableAddPatient(true);
    }
  };

  const selectAvailableDevice = (e, currentValue) => {
    if (e) e.persist();
    let list = deviceData;
    let deviceMasterID = "";
    let deviceId = null;
    list.forEach((device) => {
      if (currentValue === device.device_id && device.selected !== true) {
        deviceId = currentValue;
        device.selected = true;
        deviceMasterID = device.device_master_id;
      } else {
        device.selected = false;
      }
    });
    setAddPatientForm({
      ...addPatientForm,
      country: country.value,
      deviceSelected: deviceId,
      deviceMasterID: deviceMasterID,
      deviceId: currentValue,
    });

    setdeviceData(list);
    if (deviceId === null) {
      setQuestionnaire({ ...initialQuestionnaire });
      setDisableAddPatient(false);
    } else {
      setTimeout(() => {
        const app_main_content_wrapper = document.getElementById(
          "app-main-content-wrapper"
        );
        app_main_content_wrapper.scrollTo(
          0,
          app_main_content_wrapper.scrollHeight
        );
      }, 1000);
    }
  };

  const handlePrompt = (location) => {
    if (
      addPatientForm.patientId !== "" ||
      addPatientForm.yearOfBirth !== "" ||
      addPatientForm.gender !== "" ||
      addPatientForm.selectedDiseases.length !== 0 ||
      addPatientForm.weight !== "" ||
      addPatientForm.height !== "" ||
      addPatientForm.comments !== "" ||
      addPatientForm.atRisk === true
    ) {
      setShowPrompt(true);
      if (location) {
        setNewLocation(location.pathname);
      }
      return false;
    }
  };

  const onConfirmModal = () => {
    props.reset_new_patient_validation();
    setShowPrompt(false);

    // setRedirectURL()
    setPreventRedirect(false);
  };

  const cancelConfirmModal = () => {
    setShowPrompt(false);
  };
  return (
    <div className="patient-information-page">
      <Link className="back-link" to="" onClick={() => props.history.goBack()}>
        <IntlMessages id="newpatient.backTo" />
      </Link>
      <div className="patient-information-wrapper">
        <h2 className="add-new-title">
          <IntlMessages id="dashboard.addNewPatient" />
        </h2>
        {addPatientForm.addPatientPageNo === 1 ? (
          <form onSubmit={validateForm}>
            <div>
              <div className="patient-block">
                <div className="patient-block-title">
                  <div className="block-title">
                    <i className="zmdi zmdi-account zmdi-hc-fw" />
                    <span>
                      <IntlMessages id="newpatient.basic" />
                    </span>
                  </div>
                  <div className="star-color-before">
                    <IntlMessages id="main.mandatory" />
                  </div>
                </div>
                <div className="field-group">
                  <div className="field-block">
                    <label className="field-label star-color-after">
                      <IntlMessages id="mypatients.patientId" />
                    </label>
                    <TextField
                      variant="outlined"
                      className="patient-field custom-input action-input"
                      disabled={
                        addPatientForm.patientId === patients.generated_id
                      }
                      value={addPatientForm.patientId}
                      onChange={(e) => {
                        if (e.target.value.length <= 20) {
                          setAddPatientForm({
                            ...addPatientForm,
                            patientId: e.target.value,
                          });
                          if (!new RegExp(/\W/g).test(e.target.value)) {
                            setFormErrors({
                              ...formErrors,
                              patientIDError: "",
                            });
                          } else {
                            setFormErrors({
                              ...formErrors,
                              patientIDError:
                                "Patient ID accepts characters only",
                            });
                          }
                        }
                      }}
                      InputProps={{
                        classes: { disabled: "custom-input-disable" },
                        endAdornment: (
                          <InputAdornment position="end">
                            {addPatientForm.patientId ===
                              patients.generated_id && (
                              <IconButton
                                className="clear-icon"
                                disableRipple={true}
                                aria-label="Toggle phone visibility"
                                onClick={() => {
                                  setAddPatientForm({
                                    ...addPatientForm,
                                    patientId: "",
                                  });
                                }}
                              >
                                <Close />
                              </IconButton>
                            )}
                          </InputAdornment>
                        ),
                      }}
                    />
                    {formErrors.patientIDError && (
                      <span className="error-msg">
                        {formErrors.patientIDError}
                      </span>
                    )}
                    <a
                      href="# "
                      className="field-link"
                      onClick={(e) => {
                        e.preventDefault();
                        props.generate_patient_id();
                      }}
                    >
                      <IntlMessages id="main.autoGenerate" />
                    </a>
                  </div>
                  <div className="field-block">
                    <label className="field-label star-color-after">
                      <IntlMessages id="newpatient.yearofBirth" />
                    </label>
                    <Select
                      placeholder="-- Select --"
                      value={
                        addPatientForm.yearOfBirth
                          ? {
                              label: addPatientForm.yearOfBirth,
                              value: addPatientForm.yearOfBirth,
                            }
                          : undefined
                      }
                      options={yearOptions}
                      onChange={(opt) => {
                        setAddPatientForm({
                          ...addPatientForm,
                          yearOfBirth: opt.value,
                        });
                        setFormErrors({ ...formErrors, yearOfBirthError: "" });
                      }}
                      isDisabled={false}
                      isLoading={false}
                      isClearable={false}
                      isRtl={false}
                      isSearchable={true}
                      noOptionsMessage={() => "Year not found."}
                      className="patient-field custom-react-select custom-select-box"
                      classNamePrefix="custom-react-select"
                    />
                    {formErrors.yearOfBirthError && (
                      <span className="error-msg">
                        {formErrors.yearOfBirthError}
                      </span>
                    )}
                  </div>
                  <div className="field-block full-block">
                    <label className="field-label star-color-after">
                      <IntlMessages id="newpatient.gender" />
                    </label>
                    <RadioGroup
                      aria-label="Gender"
                      name="gender"
                      className="patient-field radio-group"
                      value={addPatientForm.gender}
                      onChange={(e) => {
                        setAddPatientForm({
                          ...addPatientForm,
                          gender: e.target.value,
                        });
                        setFormErrors({ ...formErrors, genderError: "" });
                      }}
                    >
                      <FormControlLabel
                        value="M"
                        control={
                          <Radio
                            disableRipple={true}
                            icon={<img src={icon_radio_outline} alt="Icon" />}
                            checkedIcon={<img src={icon_radio} alt="Icon" />}
                            className="custom-radio"
                          />
                        }
                        label="Male"
                        className="custom-radio-wrap"
                        classes={{
                          label: "custom-radio-label",
                        }}
                      />
                      <FormControlLabel
                        value="F"
                        control={
                          <Radio
                            disableRipple={true}
                            icon={<img src={icon_radio_outline} alt="Icon" />}
                            checkedIcon={<img src={icon_radio} alt="Icon" />}
                            className="custom-radio"
                          />
                        }
                        label="Female"
                        className="custom-radio-wrap"
                        classes={{
                          label: "custom-radio-label",
                        }}
                      />
                      <FormControlLabel
                        value="O"
                        control={
                          <Radio
                            disableRipple={true}
                            icon={<img src={icon_radio_outline} alt="Icon" />}
                            checkedIcon={<img src={icon_radio} alt="Icon" />}
                            className="custom-radio"
                          />
                        }
                        label="Other"
                        className="custom-radio-wrap"
                        classes={{
                          label: "custom-radio-label",
                        }}
                      />
                    </RadioGroup>
                    {formErrors.genderError && (
                      <span className="error-msg">
                        {formErrors.genderError}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div className="patient-block">
                <div className="patient-block-title">
                  <div className="block-title">
                    <i className="zmdi zmdi-plus-circle-o zmdi-hc-fw" />
                    <span>
                      <IntlMessages id="newpatient.medical" />
                    </span>
                  </div>
                  <div className="star-color-before" />
                </div>
                <div className="field-group full-group">
                  <div className="field-block">
                    <label className="field-label star-color-after">
                      <IntlMessages id="newpatient.conditions" />
                    </label>
                    <div className="diseaselist-wrap grey-diseaselist-wrap">
                      <MSelect
                        multiple
                        classes={{
                          root: "diseaselist-root",
                          icon: "diseaselist-icon",
                          select: "diseaselist-select",
                          selectMenu: "diseaselist-select-menu",
                        }}
                        value={addPatientForm.selectedDiseases}
                        onChange={onSelectDisease}
                        MenuProps={{
                          getContentAnchorEl: null,
                          anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left",
                          },
                          classes: {
                            paper: "diseaselist-dropdown",
                          },
                        }}
                        onOpen={diseaseMenuToggle}
                        open={addPatientForm.diseaseMenuOpenFlag}
                        onClose={diseaseMenuToggle}
                        className="diseaselist-field"
                        input={<Input id="select-multiple-checkbox" />}
                        renderValue={(disease_list) =>
                          disease_list.length +
                          " item" +
                          (disease_list.length > 1 ? "s " : " ") +
                          "selected"
                        }
                      >
                        <Input
                          className="multiselect-search grey-multiselect-search"
                          id="disease_list_searchBox"
                          placeholder="Search condition"
                          onChange={(e) => {
                            var inputValue = e.target.value.trim();
                            var array = [];
                            array = patients.fetch_disease_list_data.filter(
                              (disease) =>
                                disease.disease_description.match(
                                  new RegExp(
                                    inputValue
                                      .split("")
                                      .join("\\w*")
                                      .replace(/\W/, ""),
                                    "i"
                                  )
                                )
                            );
                            setDiseaseList(array);
                          }}
                        />
                        {diseaseList.length > 0 ? (
                          diseaseList.map((disease) => (
                            <MenuItem
                              className="multi-select-item"
                              key={"d" + disease.disease_id}
                              value={disease.disease_description}
                            >
                              <Checkbox
                                className="multi-select-check"
                                id={"disease-checkbox-" + disease.disease_id}
                                checked={
                                  addPatientForm.selectedDiseases.indexOf(
                                    disease.disease_description
                                  ) > -1
                                }
                                icon={
                                  <img
                                    src={icon_checkbox_grey_outline}
                                    alt="Icon"
                                  />
                                }
                                checkedIcon={
                                  <img src={icon_checkbox_grey} alt="Icon" />
                                }
                              />
                              <ListItemText
                                className="multi-select-text"
                                primary={disease.disease_description}
                              />
                            </MenuItem>
                          ))
                        ) : (
                          <div className="no-data">No condition found...</div>
                        )}
                      </MSelect>
                      {formErrors.diseaseError && (
                        <span className="error-msg">
                          {formErrors.diseaseError}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="selected-options-wrap">
                    {addPatientForm.selectedDiseases &&
                      addPatientForm.selectedDiseases.map((value, i) => (
                        <Chip
                          className="selected-option"
                          key={value + i}
                          label={value}
                          onDelete={() => onDeleteDisease(value)}
                        />
                      ))}
                  </div>
                </div>
                <div className="field-group physical-field-group">
                  <div className="field-block">
                    <label className="field-label star-color-after">
                      <IntlMessages id="newpatient.weight" />
                    </label>
                    <TextField
                      variant="outlined"
                      name="weightkg"
                      className="custom-input"
                      value={addPatientForm.weight}
                      onChange={(e) => {
                        // if (e.target.value === "" || (e.target.value.length < 4 && Number(e.target.value))) {
                        //     setAddPatientForm({ ...addPatientForm, weight: e.target.value }); setFormErrors({ ...formErrors, weightError: "" })
                        // }
                        if (
                          e.target.value === "" ||
                          e.target.value.length < 7
                        ) {
                          if (Number.isInteger(e.target.value)) {
                            if (e.target.value.length < 4) {
                              setAddPatientForm({
                                ...addPatientForm,
                                weight: e.target.value,
                              });
                              setFormErrors({ ...formErrors, weightError: "" });
                            }
                          } else {
                            if (
                              new RegExp(/^\d{1,3}(\.\d{0,2})?$/g).test(
                                e.target.value
                              ) ||
                              new RegExp(/^\d{0,3}(\.\d{0,2})?$/g).test(
                                e.target.value
                              )
                            ) {
                              setAddPatientForm({
                                ...addPatientForm,
                                weight: e.target.value,
                              });
                              setFormErrors({ ...formErrors, weightError: "" });
                            }
                          }
                        }
                      }}
                      onKeyUp={calculate_bmi}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment className="input-unit" position="end">
                            kg
                          </InputAdornment>
                        ),
                      }}
                    />
                    {formErrors.weightError && (
                      <span className="error-msg">
                        {formErrors.weightError}
                      </span>
                    )}
                  </div>
                  <div className="field-block">
                    <label className="field-label star-color-after">
                      <IntlMessages id="newpatient.height" />
                    </label>
                    <TextField
                      variant="outlined"
                      name="heightkg"
                      className="custom-input"
                      value={addPatientForm.height}
                      onChange={(e) => {
                        // if (e.target.value === "" || (e.target.value.length < 4 && Number(e.target.value))) {
                        //     setAddPatientForm({ ...addPatientForm, height: e.target.value }); setFormErrors({ ...formErrors, heightError: "" })
                        // }
                        if (
                          e.target.value === "" ||
                          e.target.value.length < 7
                        ) {
                          // setEditPatientForm({ ...editPatientForm, height: e.target.value });
                          // setFormErrors({ ...formErrors, heightError: "" })
                          if (Number.isInteger(e.target.value)) {
                            if (e.target.value.length < 4) {
                              setAddPatientForm({
                                ...addPatientForm,
                                height: e.target.value,
                              });
                              setFormErrors({ ...formErrors, heightError: "" });
                            }
                          } else {
                            if (
                              new RegExp(/^\d{1,3}(\.\d{0,2})?$/g).test(
                                e.target.value
                              ) ||
                              new RegExp(/^\d{0,3}(\.\d{0,2})?$/g).test(
                                e.target.value
                              )
                            ) {
                              setAddPatientForm({
                                ...addPatientForm,
                                height: e.target.value,
                              });
                              setFormErrors({ ...formErrors, heightError: "" });
                            }
                          }
                        }
                      }}
                      onKeyUp={calculate_bmi}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment className="input-unit" position="end">
                            cm
                          </InputAdornment>
                        ),
                      }}
                    />
                    {formErrors.heightError && (
                      <span className="error-msg">
                        {formErrors.heightError}
                      </span>
                    )}
                  </div>
                  <div className="field-block static-field-block">
                    <label className="field-label">
                      <IntlMessages id="appModule.bmi" />
                    </label>
                    <div className="bmi-field">
                      <strong>{addPatientForm.bmi}</strong>
                      <span>
                        {addPatientForm.bmiState
                          ? "(" + addPatientForm.bmiState + ")"
                          : ""}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="field-group patient-status-flag">
                  <div className="field-block">
                    <FormControlLabel
                      className="checkbox-group"
                      control={
                        <Checkbox
                          className="custom-checkbox"
                          classes={{
                            checked: "action-checkbox-checked",
                            disabled: "action-checkbox-disabled",
                          }}
                          disableRipple={true}
                          icon={<img src={icon_checkbox_round} alt="Icon" />}
                          checkedIcon={
                            <img src={icon_checkbox_checked_round} alt="Icon" />
                          }
                          checked={
                            addPatientForm.atRisk === null
                              ? true
                              : addPatientForm.atRisk === null
                          }
                          onChange={() => {
                            setAddPatientForm({
                              ...addPatientForm,
                              atRisk: null,
                            });
                          }}
                          defaultValue={addPatientForm.atRisk === null}
                        />
                      }
                      label="Not Known"
                      classes={{
                        label: "custom-checkbox-label",
                      }}
                    />
                  </div>
                  <div className="field-block">
                    <FormControlLabel
                      className="checkbox-group"
                      control={
                        <Checkbox
                          className="custom-checkbox"
                          classes={{
                            checked: "action-checkbox-checked",
                            disabled: "action-checkbox-disabled",
                          }}
                          disableRipple={true}
                          icon={<img src={icon_checkbox_round} alt="Icon" />}
                          checkedIcon={
                            <img src={icon_checkbox_checked_round} alt="Icon" />
                          }
                          checked={addPatientForm.atRisk === 0}
                          onChange={() => {
                            setAddPatientForm({ ...addPatientForm, atRisk: 0 });
                          }}
                        />
                      }
                      label="Stable"
                      classes={{
                        label: "custom-checkbox-label",
                      }}
                    />
                  </div>
                  <div className="field-block">
                    <FormControlLabel
                      className="checkbox-group"
                      control={
                        <Checkbox
                          className="custom-checkbox"
                          classes={{
                            checked: "action-checkbox-checked",
                            disabled: "action-checkbox-disabled",
                          }}
                          disableRipple={true}
                          icon={<img src={icon_checkbox_round} alt="Icon" />}
                          checkedIcon={
                            <img src={icon_checkbox_checked_round} alt="Icon" />
                          }
                          checked={addPatientForm.atRisk === 2}
                          onChange={() => {
                            setAddPatientForm({ ...addPatientForm, atRisk: 2 });
                          }}
                        />
                      }
                      label="Control"
                      classes={{
                        label: "custom-checkbox-label",
                      }}
                    />
                  </div>
                  <div className="field-block">
                    <FormControlLabel
                      className="checkbox-group"
                      control={
                        <Checkbox
                          className="custom-checkbox"
                          classes={{
                            checked: "action-checkbox-checked",
                            disabled: "action-checkbox-disabled",
                          }}
                          disableRipple={true}
                          icon={<img src={icon_checkbox_round} alt="Icon" />}
                          checkedIcon={
                            <img src={icon_checkbox_checked_round} alt="Icon" />
                          }
                          checked={addPatientForm.atRisk === 1}
                          onChange={() => {
                            setAddPatientForm({ ...addPatientForm, atRisk: 1 });
                          }}
                        />
                      }
                      label="At Risk"
                      classes={{
                        label: "custom-checkbox-label",
                      }}
                    />
                  </div>
                </div>
                <div />
                <div className="field-group patient-comment-group">
                  <div className="field-block">
                    <label className="field-label">
                      <IntlMessages id="newpatient.comments" />
                    </label>
                    <TextField
                      className="comment-textarea"
                      type="textarea"
                      value={addPatientForm.comments}
                      onChange={(e) => {
                        if (e.target.value.length <= 1024) {
                          setAddPatientForm({
                            ...addPatientForm,
                            comments: e.target.value,
                          });
                        }
                      }}
                      variant="outlined"
                      multiline={true}
                      rows={3}
                      rowsMax={4}
                      fullWidth
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="btn-wrap patient-info-footer">
              <Button
                className="secondary-button"
                disableRipple={true}
                disableFocusRipple={true}
                onClick={cancelAddPatient}
              >
                <IntlMessages id="main.cancel" />
              </Button>
              <Button
                className="primary-button"
                type="submit"
                disableRipple={true}
                disableFocusRipple={true}
                onClick={() => {}}
              >
                <IntlMessages id="main.next" />
              </Button>
            </div>
          </form>
        ) : (
          <>
            <div>
              <div
                className="patient-block"
                id="add_patient_device_information"
              >
                <div className="patient-block-title">
                  <div className="block-title">
                    <img src={device_information} alt="Icon" />
                    <span>
                      <IntlMessages id="newpatient.deviceInformation" />
                    </span>
                  </div>
                </div>
                {reqestPastDateDeployDevice && (
                  <div className="field-group error-msg">
                    {reqestPastDateDeployDevice}
                  </div>
                )}
                <div className="field-group">
                  <div className="device-info-left">
                    <div className="calendar-field">
                      <label className="field-label">
                        <IntlMessages id="newpatient.deviceAllocation" />
                      </label>
                      <div className="grey-calendar-wrapper green-dots-calendar">
                        <DatePicker
                          // minDate={moment.utc().toDate()}
                          selected={addPatientForm.deviceAllocationDate}
                          dateFormat="dd MMM yyyy"
                          calendarClassName="custom-calendar grey-calendar"
                          customInput={<CustomDateInput />}
                          highlightDates={greenDotDates}
                          onChange={(date) => {
                            if (
                              dayjs.utc(date).format("YYYY-MM-DD") >=
                              dayjs.utc().format("YYYY-MM-DD")
                            ) {
                              let dates_selection = {
                                deviceAllocationDate: dayjs.utc(date).toDate(),
                              };
                              if (
                                dayjs.utc(date).format("YYYY-MM-DD") >=
                                dayjs
                                  .utc(addPatientForm.deviceDeallocationDate)
                                  .format("YYYY-MM-DD")
                              ) {
                                dates_selection = {
                                  ...dates_selection,
                                  deviceDeallocationDate: dayjs
                                    .utc(date)
                                    .add(1, "days")
                                    .toDate(),
                                };
                              }

                              setAddPatientForm({
                                ...addPatientForm,
                                ...dates_selection,
                              });
                              setPastDate(null);
                              setPastDateAllocation(false);
                            } else {
                              setPastDate(date);
                              setPastDateAllocation(true);
                            }
                          }}
                          renderCustomHeader={({
                            date,
                            decreaseMonth,
                            increaseMonth,
                            prevMonthButtonDisabled,
                            nextMonthButtonDisabled,
                          }) => (
                            <div className="calendar-controls">
                              <div className="left-controls">
                                <span>{dayjs(date).format("MMMM")} </span>
                                <span>{dayjs(date).year()}</span>
                              </div>
                              <div className="right-controls">
                                <span
                                  className="zmdi zmdi-chevron-left zmdi-hc-fw"
                                  onClick={decreaseMonth}
                                  disabled={prevMonthButtonDisabled}
                                />
                                <span
                                  className="zmdi zmdi-chevron-right zmdi-hc-fw"
                                  onClick={increaseMonth}
                                  disabled={nextMonthButtonDisabled}
                                />
                              </div>
                            </div>
                          )}
                        />
                      </div>
                    </div>
                    <div className="calendar-field">
                      <label className="field-label">
                        <IntlMessages id="newpatient.deviceReturn" />
                      </label>
                      <div className="grey-calendar-wrapper">
                        <DatePicker
                          minDate={dayjs
                            .utc(addPatientForm.deviceAllocationDate)
                            .add(1, "days")
                            .toDate()}
                          selected={addPatientForm.deviceDeallocationDate}
                          dateFormat="dd MMM yyyy"
                          calendarClassName="custom-calendar grey-calendar"
                          customInput={<CustomDateInput />}
                          onChange={(date) => {
                            setAddPatientForm({
                              ...addPatientForm,
                              deviceDeallocationDate: date,
                            });
                          }}
                          renderCustomHeader={({
                            date,
                            decreaseMonth,
                            increaseMonth,
                            prevMonthButtonDisabled,
                            nextMonthButtonDisabled,
                          }) => (
                            <div className="calendar-controls">
                              <div className="left-controls">
                                <span>{dayjs(date).format("MMMM")} </span>
                                <span>{dayjs(date).year()}</span>
                              </div>
                              <div className="right-controls">
                                <span
                                  className="zmdi zmdi-chevron-left zmdi-hc-fw"
                                  onClick={decreaseMonth}
                                  disabled={prevMonthButtonDisabled}
                                />
                                <span
                                  className="zmdi zmdi-chevron-right zmdi-hc-fw"
                                  onClick={increaseMonth}
                                  disabled={nextMonthButtonDisabled}
                                />
                              </div>
                            </div>
                          )}
                        />
                      </div>
                    </div>
                    <div className="duration-field">
                      <label className="field-label">
                        <IntlMessages id="newpatient.duration" />
                      </label>
                      <span>
                        {addPatientForm.nightsBetween}{" "}
                        {addPatientForm.nightsBetween > 1
                          ? " Nights"
                          : " Night"}
                      </span>
                    </div>
                    <div className="field-block pb-4">
                      <label className="field-label py-2 star-color-after">
                        <IntlMessages id="mypatients.timezone" />
                      </label>
                      <TimezoneSelect
                        timezones={{
                          ...allTimezones,
                        }}
                        labelStyle="original"
                        value={country.value}
                        onChange={(v) => handleInputChange("country", v.value)}
                        required={true}
                        id="country"
                        name="country"
                      />
                    </div>
                    {/* <label className="window-start-time field-label star-color-after">
                        <IntlMessages id="newpatient.startTime"></IntlMessages>
                      </label>
                      <div className="grey-calendar-wrapper">
                        <TimePicker
                            popupStyle={{ zIndex: 1500 }}
                            open={openStartWindow}
                            onOpenChange={open => setOpenStartWindow(open)}
                            onChange={time => {
                                setAddPatientForm({
                                ...addPatientForm,
                                window_start_time: time || dayjs('19:00:00', 'HH:mm:ss'),
                                });
                            }}
                            value={dayjs(addPatientForm.window_start_time)}
                        />
                      </div>
                      <label className="field-label">
                        <IntlMessages id="newpatient.stopTime"></IntlMessages>
                      </label> */}
                      {/* <div className="grey-calendar-wrapper">
                        <TimePicker
                            popupStyle={{ zIndex: 1500 }}
                            open={openStopWindow}
                            onOpenChange={open => setOpenStopWindow(open)}
                            onChange={time => {
                                setAddPatientForm({
                                    ...addPatientForm,
                                    window_end_time: time || dayjs('10:00:00', 'HH:mm:ss'),
                                });
                            }}
                            value={dayjs(addPatientForm.window_end_time)}
                        />
                      </div> */}
                      <div className="field-block">
                      <label className="field-label">
                        <IntlMessages id="newpatient.startTime"></IntlMessages>
                      </label>
                      <div>
                        {addPatientForm.window_start_time
                          ? addPatientForm.window_start_time
                          : 'N/A'}
                      </div>
                    </div>
                    <div className="field-block">
                      <label className="field-label">
                        <IntlMessages id="newpatient.stopTime"></IntlMessages>
                      </label>
                      <div>
                        {addPatientForm.window_end_time
                          ? addPatientForm.window_end_time
                          : 'N/A'}
                      </div>
                    </div>
                    <div className="field-col-block">
                      <label className="window_time_change pt-1 field-label">
                        <IntlMessages id="editpatient.changeWinTime"></IntlMessages>
                      </label>
                    </div>
                  </div>
                  <div className="device-info-wrap">
                    <div className="device-info-right">
                      <div className="table-search-block patient-table-right">
                        <div className="device-table-title">
                          Available Devices
                        </div>
                        <TextField
                          variant="outlined"
                          className="custom-input"
                          placeholder="Search Device"
                          value={searchDeviceId}
                          onChange={(e) => setSearchDeviceId(e.target.value)}
                          InputProps={{
                            classes: {
                              root: "input-field-root",
                            },
                          }}
                          onKeyPress={(e) => {
                            validateSearchText(e);
                          }}
                        />
                      </div>
                      <div className="device-table">
                        {deviceData.length > 0 ? (
                          <>
                            <div className="device-tabel-row transparent-row">
                              <div className="device-col-1">
                                <IntlMessages id="mypatients.deviceId" />
                              </div>
                              <div className="device-col-2">
                                <IntlMessages id="newpatient.deviceAvailableFrom" />
                              </div>
                              <div className="device-col-3">
                                <IntlMessages id="newpatient.deviceAvailableUntil" />
                              </div>
                              <div className="device-col-4" />
                            </div>
                            {deviceData.filter((f) =>
                              f.device_id
                                .toUpperCase()
                                .includes(searchDeviceId.toUpperCase())
                            ).length === 0 && (
                              <div className="device-tabel-row">
                                No record found.
                              </div>
                            )}
                            {deviceData
                              .filter((f) =>
                                f.device_id
                                  .toUpperCase()
                                  .includes(searchDeviceId.toUpperCase())
                              )
                              .map((d) => (
                                <div
                                  key={d.device_id}
                                  className={
                                    "device-tabel-row " +
                                    (addPatientForm.deviceSelected ==
                                    d.device_id
                                      ? "active"
                                      : "")
                                  }
                                  onClick={(e) => {
                                    selectAvailableDevice(e, d.device_id);
                                  }}
                                >
                                  <div className="device-col-1">
                                    {d.device_id}
                                  </div>
                                  <div className="device-col-2">
                                    {getLocalMoment(
                                      d.device_allocation_date
                                    ).format("DD MMM YYYY")}
                                  </div>
                                  <div className="device-col-3">
                                    {getLocalMoment(
                                      d.device_deallocation_date
                                    ).format("DD MMM YYYY")}
                                  </div>
                                  <div className="device-col-4 radio-group">
                                    <Radio
                                      checked={
                                        d.selected !== undefined
                                          ? d.selected
                                          : false
                                      }
                                      disableRipple={true}
                                      value={d.device_id}
                                      className="custom-radio"
                                      icon={
                                        <img
                                          src={icon_checkbox_round}
                                          alt="Icon"
                                        />
                                      }
                                      checkedIcon={
                                        <img
                                          src={icon_checkbox_checked_round}
                                          alt="Icon"
                                        />
                                      }
                                    />
                                  </div>
                                </div>
                              ))}
                          </>
                        ) : (
                          <div>
                            <IntlMessages id="newpatient.noDeviceFound" />
                          </div>
                        )}
                      </div>
                    </div>
                    {addPatientForm.deviceSelected &&
                      addPatientForm.deviceSelected != "" && (
                        <div className="question-wrap">
                          <div className="question-field">
                            <label className="question-label">
                              <IntlMessages id="newpatient.implantedActiveDevice" />
                            </label>
                            <div>
                              <RadioGroup
                                aria-label="question1"
                                name="question1"
                                className="patient-field radio-group"
                                onChange={(e) => {
                                  toggleQuestionHandle("first", e.target.value);
                                }}
                                value={questionnaire.first}
                              >
                                <FormControlLabel
                                  value="no"
                                  control={
                                    <Radio
                                      disableRipple={true}
                                      icon={
                                        <img
                                          src={icon_radio_grey_outline}
                                          alt="Icon"
                                        />
                                      }
                                      checkedIcon={
                                        <img src={icon_radio_grey} alt="Icon" />
                                      }
                                      className="custom-radio"
                                    />
                                  }
                                  label="No"
                                  className="custom-radio-wrap"
                                  classes={{
                                    label: "custom-radio-label",
                                  }}
                                />
                                <FormControlLabel
                                  value="yes"
                                  control={
                                    <Radio
                                      disableRipple={true}
                                      icon={
                                        <img
                                          src={icon_radio_grey_outline}
                                          alt="Icon"
                                        />
                                      }
                                      checkedIcon={
                                        <img src={icon_radio_grey} alt="Icon" />
                                      }
                                      className="custom-radio"
                                    />
                                  }
                                  label="Yes"
                                  className="custom-radio-wrap"
                                  classes={{
                                    label: "custom-radio-label",
                                  }}
                                />
                              </RadioGroup>
                              {questionnaire.first === "yes" && (
                                <div className="error-msg">
                                  <IntlMessages id="newpatient.implantedActiveDeviceMsg" />
                                </div>
                              )}
                            </div>
                          </div>
                          {questionnaire.first === "no" && (
                            <div className="question-field">
                              <label className="question-label">
                                <IntlMessages id="newpatient.patientPregnant" />
                              </label>
                              <RadioGroup
                                aria-label="question2"
                                name="question2"
                                className="patient-field radio-group"
                                onChange={(e) => {
                                  toggleQuestionHandle(
                                    "second",
                                    e.target.value
                                  );
                                }}
                                value={questionnaire.second}
                              >
                                <FormControlLabel
                                  value="no"
                                  control={
                                    <Radio
                                      disableRipple={true}
                                      icon={
                                        <img
                                          src={icon_radio_grey_outline}
                                          alt="Icon"
                                        />
                                      }
                                      checkedIcon={
                                        <img src={icon_radio_grey} alt="Icon" />
                                      }
                                      className="custom-radio"
                                    />
                                  }
                                  label="No"
                                  className="custom-radio-wrap"
                                  classes={{
                                    label: "custom-radio-label",
                                  }}
                                />
                                <FormControlLabel
                                  value="yes"
                                  control={
                                    <Radio
                                      disableRipple={true}
                                      icon={
                                        <img
                                          src={icon_radio_grey_outline}
                                          alt="Icon"
                                        />
                                      }
                                      checkedIcon={
                                        <img src={icon_radio_grey} alt="Icon" />
                                      }
                                      className="custom-radio"
                                    />
                                  }
                                  label="Yes"
                                  className="custom-radio-wrap"
                                  classes={{
                                    label: "custom-radio-label",
                                  }}
                                />
                              </RadioGroup>
                              {questionnaire.second === "yes" && (
                                <div className="error-msg">
                                  <IntlMessages id="newpatient.patientPregnantMsg" />
                                </div>
                              )}
                            </div>
                          )}
                          {questionnaire.first === "no" &&
                            questionnaire.second === "no" && (
                              <div className="question-field">
                                <label className="question-label">
                                  <IntlMessages id="newpatient.underAge" />
                                </label>
                                <RadioGroup
                                  aria-label="Question3"
                                  name="question3"
                                  className="patient-field radio-group"
                                  onChange={(e) => {
                                    toggleQuestionHandle(
                                      "third",
                                      e.target.value
                                    );
                                  }}
                                  value={questionnaire.third}
                                >
                                  <FormControlLabel
                                    value="no"
                                    control={
                                      <Radio
                                        disableRipple={true}
                                        icon={
                                          <img
                                            src={icon_radio_grey_outline}
                                            alt="Icon"
                                          />
                                        }
                                        checkedIcon={
                                          <img
                                            src={icon_radio_grey}
                                            alt="Icon"
                                          />
                                        }
                                        className="custom-radio"
                                      />
                                    }
                                    label="No"
                                    className="custom-radio-wrap"
                                    classes={{
                                      label: "custom-radio-label",
                                    }}
                                  />
                                  <FormControlLabel
                                    value="yes"
                                    control={
                                      <Radio
                                        disableRipple={true}
                                        icon={
                                          <img
                                            src={icon_radio_grey_outline}
                                            alt="Icon"
                                          />
                                        }
                                        checkedIcon={
                                          <img
                                            src={icon_radio_grey}
                                            alt="Icon"
                                          />
                                        }
                                        className="custom-radio"
                                      />
                                    }
                                    label="Yes"
                                    className="custom-radio-wrap"
                                    classes={{
                                      label: "custom-radio-label",
                                    }}
                                  />
                                </RadioGroup>
                                {questionnaire.third === "yes" && (
                                  <div className="error-msg">
                                    <IntlMessages id="newpatient.underAgeMsg" />
                                  </div>
                                )}
                              </div>
                            )}
                          {questionnaire.first === "no" &&
                            questionnaire.second === "no" &&
                            questionnaire.third === "no" && (
                              <div className="question-field">
                                <label className="question-label">
                                  I shared the{" "}
                                  <a
                                    href={consent_Form_pdf}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    Patient Information Sheet
                                  </a>{" "}
                                  with the patient.
                                </label>
                                <RadioGroup
                                  aria-label="Question4"
                                  name="question4"
                                  className="patient-field radio-group"
                                  onChange={(e) => {
                                    toggleQuestionHandle(
                                      "forth",
                                      e.target.value
                                    );
                                  }}
                                  value={questionnaire.forth}
                                >
                                  <FormControlLabel
                                    value="no"
                                    control={
                                      <Radio
                                        disableRipple={true}
                                        icon={
                                          <img
                                            src={icon_radio_grey_outline}
                                            alt="Icon"
                                          />
                                        }
                                        checkedIcon={
                                          <img
                                            src={icon_radio_grey}
                                            alt="Icon"
                                          />
                                        }
                                        className="custom-radio"
                                      />
                                    }
                                    label="No"
                                    className="custom-radio-wrap"
                                    classes={{
                                      label: "custom-radio-label",
                                    }}
                                  />
                                  <FormControlLabel
                                    value="yes"
                                    control={
                                      <Radio
                                        disableRipple={true}
                                        icon={
                                          <img
                                            src={icon_radio_grey_outline}
                                            alt="Icon"
                                          />
                                        }
                                        checkedIcon={
                                          <img
                                            src={icon_radio_grey}
                                            alt="Icon"
                                          />
                                        }
                                        className="custom-radio"
                                      />
                                    }
                                    label="Yes"
                                    className="custom-radio-wrap"
                                    classes={{
                                      label: "custom-radio-label",
                                    }}
                                  />
                                </RadioGroup>
                                {questionnaire.forth === "no" && (
                                  <div className="error-msg">
                                    <IntlMessages id="newpatient.patientInformationSheetNo" />
                                  </div>
                                )}
                                {questionnaire.forth === "yes" && (
                                  <div className="error-msg">
                                    <IntlMessages id="newpatient.patientInformationSheetYes" />
                                  </div>
                                )}
                              </div>
                            )}
                        </div>
                      )}
                  </div>
                </div>
              </div>
            </div>
            <div className="btn-wrap patient-info-footer">
              <Button
                className="back-button"
                disableRipple={true}
                disableFocusRipple={true}
                onClick={() => {
                  setAddPatientForm({ ...addPatientForm, addPatientPageNo: 1 });
                }}
              >
                <IntlMessages id="main.previous" />
              </Button>
              <div>
                <Button
                  className="secondary-button"
                  disableRipple={true}
                  disableFocusRipple={true}
                  onClick={cancelAddPatient}
                >
                  <IntlMessages id="main.cancel" />
                </Button>
                <Button
                  className={
                    "primary-button " +
                    (disableAddPatient ||
                    patients.is_adding_patient ||
                    // addPatientForm.deviceSelected === "" ||
                    // !addPatientForm.deviceSelected ||
                    addPatientForm.country === "" ||
                    !addPatientForm.country
                      ? "disabled-field"
                      : "")
                  }
                  disableRipple={true}
                  disabled={patients.is_adding_patient}
                  disableFocusRipple={true}
                  onClick={addNewPatient}
                >
                  <IntlMessages id="main.confirm" />
                </Button>
              </div>
            </div>
          </>
        )}
      </div>
      <PastDateAllocationDevice
        isOpen={pastDateAllocation}
        deployError={deployError}
        patientId={""}
        patientCode={addPatientForm.patientId}
        deviceId={addPatientForm.deviceSelected}
        allocationDate={dayjs(pastDate).format("DD MMM YYYY")}
        deallocationDate={dayjs(addPatientForm.deviceDeallocationDate).format(
          "DD MMM YYYY"
        )}
        deployDevice={() => {
          setPastDateAllocation(false);
          setAddPatientForm({
            ...addPatientForm,
            deviceAllocationDate: pastDate,
          });
        }}
        handleSuccessDeploy={() => {
          setPastDateSuccess(true);
        }}
        page={"add-patient"}
        onCancel={() => {
          setPastDateAllocation(false);
          if (patients.is_patient_added) {
            //setNewLocation('/app/patients');
            props.history.goBack();
            setPreventRedirect(false);
          }
        }}
      />
      <PastDateDeliverySuccess
        isOpen={pastDateSuccess}
        onCancel={() => setPastDateSuccess(false)}
      />
      <Prompt when={preventRedirect} message={handlePrompt} />
      {showPrompt && (
        <ConfirmDialog
          onConfirm={onConfirmModal}
          onCancel={cancelConfirmModal}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  ...state,
  patients: state.patients,
  user: state.user,
  doctor_id: state.user.user_details.user_id,
});

const mapDispatchToProps = (dispatch) => ({
  fetch_disease_list: (payload) => dispatch(fetch_disease_list_action(payload)),
  fetch_available_devices: (payload) =>
    dispatch(fetch_available_devices_action(payload)),
  generate_patient_id: () => dispatch(generate_patient_id_action()),
  deployDevice: (payload) => dispatch(device_operation(payload)),
  add_new_patient: (...payload) => dispatch(add_new_patient_action(...payload)),
  fetch_available_devices_dates: () =>
    dispatch(fetch_available_devices_dates_action()),
  reset_new_patient_validation: () =>
    dispatch(reset_new_patient_validation_action()),
  reset_new_patient_response: () =>
    dispatch(reset_new_patient_response__action()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddPatient);
